module.exports = __webpack_public_path__ + "static/media/icon-display-star.21997f26.svg";